<template>
  <BaseButton ghost small @click="open">
    <span class="truncate"> Edit </span>
  </BaseButton>
</template>

<script>
import { contactAccountsClient } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
    account: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showForm: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/ContactAccounts/AccountEditModal.vue'),
        props: {
          action: async (data) => {
            try {
              await contactAccountsClient.update(
                this.contactId,
                this.account.id,
                mapKeysToSnakeCase(data)
              );

              this.$emit('account-updated');

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            }
          },
          account: this.account,
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
